import React from 'react';
import { Box, Text } from '@gluestack-ui/themed';

interface LevelHeaderProps {
  levelNr: number;
  title: string;
}

const LevelHeader: React.FC<LevelHeaderProps> = ({ levelNr, title }) => (
  <Box px="$4" pt="$6" pb="$2">
    <Text size="2xs" fontWeight="bold" color="$textSubtle" textTransform="uppercase" letterSpacing="$md">
      Level
      {' '}
      {levelNr}
      :
      {' '}
      {title}
    </Text>
  </Box>
);

export default LevelHeader;
